import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import s from "./Preloader.less";
import clsx from "clsx";

interface IProps {
  noText?: boolean;
  wrap?: boolean;
}

const Preloader: FC<IProps> = ({ noText = false, wrap = false }) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(s.wrap, {
        [s.wrapper]: wrap,
      })}
    >
      <div className={s.loading}>
        <div
          className={clsx(s.bounceball, {
            [s.no_text]: noText,
          })}
        />
        <div className={s.text}>{!noText && `${t("ui.loading")}...`}</div>
      </div>
    </div>
  );
};
export default Preloader;
